// @ts-nocheck
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App.tsx";
// import './index.css';
/* import './App.css'; */
import { Amplify } from "aws-amplify";
import { Authenticator } from "@aws-amplify/ui-react";
import { ApolloProvider } from "@apollo/client";
import { client } from "./apollo_client.tsx";
import { applyTheme } from "@cloudscape-design/components/theming";
import { theme } from "./layouts/shell/styles.tsx"; // Assuming this is the correct path

applyTheme({ theme });

// Amplify.configure({
//   Auth: {
//     region: process.env.REGION,
//     userPoolId: process.env.USER_POOL_ID,
//     userPoolWebClientId: process.env.USER_POOL_APP_CLIENT_ID,
//   },
// });
// const aws_exports = require('./aws-exports').default;

import aws_exports from "./aws-exports.js";
Amplify.configure(aws_exports);

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <ApolloProvider client={client}>
      <Authenticator.Provider>
        <App />
      </Authenticator.Provider>
    </ApolloProvider>
  </React.StrictMode>
);
